import React, { useEffect, useRef } from "react";
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminExtraProductCharge,
  initializeRateAdminExtraProductChargeScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminExtraProductCharge,
  deleteRateAdminExtraProductCharge,
  saveExtraProductChargeTableState,
} from "../../../redux/actions/RateAdmin/rateadminExtraProductCharge";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import RateAdminExtraProductCharge from "../../../component/RateAdmin/RateAdminExtraProductCharge";
import { generatePath } from "react-router-dom";
import { loadingShow } from "../../../services/PostAPI";
import { APP_URLS } from "../../../utils/constant";
import { ProgressBar } from "primereact/progressbar";
function RateAdminExtraProductChargeScreen(props) {
  const {
    fetchRateAdminExtraProductCharge,
    initRateAdminExtraProductChargeScreen,
    showPageLevelLoader,
    rateAdminExtraProductChargeListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminExtraProductCharge,
    isRateAdminExtraProductChargeExportError,
    isRateAdminExtraProductChargeExportSuccess,
    deleteRateAdminExtraProductCharge,
    shouldOpenDeleteConfirmationPopup,
    setDeleteConfirmationPopupVisibility,
    isRateAdminExtraProductChargeDeleteSuccess,
    isRateAdminExtraProductChargeDeleteError,
    isLoading,
    savedTableState,
    saveExtraProductChargeTableState,
  } = props;

  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  const callAPIasync = async () => {
    initRateAdminExtraProductChargeScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      await fetchRateAdminExtraProductCharge(savedParams);
    } else {
      await fetchRateAdminExtraProductCharge({ sortField: "id" });
    }
  };

  useEffect(() => {
    callAPIasync();
  }, []);
  const loadLazyData = (props) => {
    fetchRateAdminExtraProductCharge(props);
  };

  const handleTableStateChange = (tableState) => {
    saveExtraProductChargeTableState(tableState);
  };

  const handleCreateRateAdminExtraProductCharge = () => {
    navigate(APP_URLS.RATEADMIN_EXTRAPRODUCTCHARGE.CREATE);
  };
  const editRateAdminExtraProductChargeRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_EXTRAPRODUCTCHARGE.EDIT, {
      id,
    });
    navigate(path);
  };
  const copyRateAdminExtraProductChargeRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_EXTRAPRODUCTCHARGE.COPY, {
      id,
    });
    navigate(path);
  };

  const rateAdminExtraProductCharge = {
    handleCreateRateAdminExtraProductCharge,
    exportRateAdminExtraProductCharge,
    isRateAdminExtraProductChargeExportError,
    isRateAdminExtraProductChargeExportSuccess,
    deleteRateAdminExtraProductCharge,
    isRateAdminExtraProductChargeDeleteSuccess,
    isRateAdminExtraProductChargeDeleteError,
    editRateAdminExtraProductChargeRoute,
    copyRateAdminExtraProductChargeRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    fetchRateAdminExtraProductCharges: loadLazyData,
    tableData: {
      columns: rateAdminExtraProductChargeListview?.columns,
      rows: rateAdminExtraProductChargeListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      {isLoading && renderProgressBar()}
      <RateAdminExtraProductCharge {...rateAdminExtraProductCharge} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminExtraProductChargeScreen: () =>
      dispatch(initializeRateAdminExtraProductChargeScreen()),
    fetchRateAdminExtraProductCharge: (payload) =>
      dispatch(fetchRateAdminExtraProductCharge(payload)),
    deleteRateAdminExtraProductCharge: (payload) =>
      dispatch(deleteRateAdminExtraProductCharge(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminExtraProductCharge: (payload) =>
      dispatch(exportRateAdminExtraProductCharge(payload)),
    saveExtraProductChargeTableState: (payload) =>
      dispatch(saveExtraProductChargeTableState(payload)),
  };
};

//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {
    isRateAdminExtraProductChargeCreateSuccess:
      selectFromRateAdminExtraProductChargeReducer(
        state,
        "isRateAdminExtraProductChargeCreateSuccess"
      ),
    shouldOpenDeleteConfirmationPopup:
      selectFromRateAdminExtraProductChargeReducer(
        state,
        "shouldOpenDeleteConfirmationPopup"
      ),
    isLoading: selectFromRateAdminExtraProductChargeReducer(state, "isLoading"),
    rateAdminExtraProductChargeListview:
      selectFromRateAdminExtraProductChargeReducer(
        state,
        "rateAdminExtraProductChargeListview"
      ),
    showPageLevelLoader: selectFromRateAdminExtraProductChargeReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminExtraProductChargeReducer(
      state,
      "paginationInfo"
    ),

    isRateAdminExtraProductChargeDeleteSuccess:
      selectFromRateAdminExtraProductChargeReducer(
        state,
        "isRateAdminExtraProductChargeDeleteSuccess"
      ),
    isRateAdminExtraProductChargeDeleteError:
      selectFromRateAdminExtraProductChargeReducer(
        state,
        "isRateAdminExtraProductChargeDeleteError"
      ),
    isPageLevelError: selectFromRateAdminExtraProductChargeReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminExtraProductChargeReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminExtraProductChargeExportError:
      selectFromRateAdminExtraProductChargeReducer(
        state,
        "isRateAdminExtraProductChargeExportError"
      ),

    isRateAdminExtraProductChargeExportSuccess:
      selectFromRateAdminExtraProductChargeReducer(
        state,
        "isRateAdminExtraProductChargeExportSuccess"
      ),
    savedTableState: selectFromRateAdminExtraProductChargeReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminExtraProductChargeReducer = (state, path) => {
  return selectRateAdminExtraProductChargeReducer(state)[path];
};

const selectRateAdminExtraProductChargeReducer = ({
  rateadminExtraProductChargeReducer,
}) => {
  return rateadminExtraProductChargeReducer;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RateAdminExtraProductChargeScreen);
